import { Component, OnInit } from '@angular/core';
import { PageTestsService } from '../../data/page-tests.service';
import { User } from 'projects/core/src/lib/login/data/user';
import { TicketsPage } from '../../data/tickets-page';
import moment from 'moment';

interface CbUser {
	name: string;
}

@Component({
	selector: 'app-tickets-tests-page',
	templateUrl: './tickets-tests-page.component.html',
	styleUrls: ['./tickets-tests-page.component.scss']
})
export class TicketsTestsPageComponent implements OnInit {

	users: CbUser[]

	selectedUser: CbUser;

	startDate: Date;
	endDate: Date;

	ticketPage: TicketsPage;

	loadingSpinner: boolean;

	codebaselink = 'https://rteamkz.codebasehq.com'

	constructor(
		protected pageTestsService: PageTestsService
	) { }

	ngOnInit(): void {
		this.pageTestsService.getCBUsers().subscribe(users => {
			this.users = users.map(user => ({
				name: user,
			}))
			this.selectedUser = this.users.find(user => user.name.includes('danil'))
		})
	}

	somethingChanged() {
		if (this.startDate && this.endDate) {
			this.loadingSpinner = true;
			this.pageTestsService.getCBTests(this.selectedUser.name, moment(this.startDate).format('YYYY-MM-DD'), moment(this.endDate).format('YYYY-MM-DD')).subscribe(page => {
				this.ticketPage = page
				this.ticketPage.tickets.forEach(ticket => {
					if (ticket.testTicket) {
						console.log(ticket.testTicket.summary)
					}
				})
				this.loadingSpinner = false;
			})
		}
	}

	openTicket(ticketId: number) {
		if (ticketId) {
			window.open(this.codebaselink + '/projects/ac/tickets/' + ticketId);
		}
	}


}
